export const TEST_ID = 'recenterMapIcon';
